export default __webpack_public_path__ + "static/media/achievement.721f42e3.svg";